import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, History, Target, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const MODES = [
  { icon: History, title: "Previous Years", desc: "Attempt authentic past-paper questions filtered by exam, subject and difficulty.", to: "/student/practice/pyq", tone: "bg-blue-50 text-blue-600", cta: "Browse PYQ" },
  { icon: Target, title: "Practice by Topic", desc: "Pick a subject and chapter, then start a focused practice session.", to: "/student/practice/topic", tone: "bg-amber-50 text-amber-600", cta: "Pick a chapter" },
  { icon: Zap, title: "AI Questions", desc: "Fresh, exam-authentic questions generated by VIGS and verified by experts.", to: "/student/practice/ai", tone: "bg-violet-50 text-violet-600", cta: "Start AI practice" },
];

export default function PracticeHub() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-5xl" data-testid="practice-hub">
      <div className="mb-8">
        <h1 className="font-heading text-2xl font-bold tracking-tight">Choose how you want to practise</h1>
        <p className="mt-2 text-muted-foreground">Three ways to build mastery — pick one to get started.</p>
      </div>
      <div className="grid gap-5 md:grid-cols-3">
        {MODES.map((m, i) => (
          <motion.button
            key={m.title}
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}
            onClick={() => navigate(m.to)}
            data-testid={`mode-${m.title.split(" ")[0].toLowerCase()}`}
            className="group flex flex-col rounded-2xl border border-border bg-card p-6 text-left transition-colors hover:border-blue-300"
          >
            <span className={cn("mb-4 flex h-12 w-12 items-center justify-center rounded-xl", m.tone)}><m.icon className="h-6 w-6" /></span>
            <h2 className="font-heading text-lg font-semibold">{m.title}</h2>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{m.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-blue-600">{m.cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
          </motion.button>
        ))}
      </div>
    </div>
  );
}
